<template>
    <div class="card" v-if="event">
        <div class="card-header" v-if="event.source">
            <h5 class="card-title" v-if="event.title">{{ event.title }}</h5>
            <p class="card-text text-center" v-if="event.source">
                <i class="fas fa-link"></i> Source: {{ event.source }}
            </p>
        </div>

        <div class="card-body">
            {{ event }}

            <div class="row" v-if="event.external_id">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-archive"></i> External ID:</div>
                <div class="col-6">{{ event.external_id }}</div>
            </div>
            <div class="row" v-if="event.data.publication_date">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-calendar-alt"></i> Publication Date:</div>
                <div class="col-6">{{ event.data.publication_date.value }}</div>
            </div>
            <div class="row" v-if="event.data.event_date">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-calendar-day"></i> Event Date:</div>
                <div class="col-6">{{ event.data.event_date.value }}</div>
            </div>
            <div class="row" v-if="event.data.disease">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-vial"></i> Disease / Serotypes:</div>
                <div class="col-6">{{ event.data.disease.value }}</div>
            </div>
            <div class="row" v-if="event.data.species">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-dog"></i> Species:</div>
                <div class="col-6">{{ event.data.species.value }}</div>
            </div>
            <div class="row" v-if="event.data.mortality">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-heartbeat"></i> Mortality:</div>
                <div class="col-6" v-if="event.data.mortality.value.cases || event.data.mortality.value.deaths">
                    {{ event.data.mortality.value.cases }} cases
                    <span v-if="event.data.mortality.value.deaths">({{ event.data.mortality.value.deaths }} deaths)</span>
                </div>
            </div>
            <div class="row" v-if="event.data.dates">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-calendar"></i> Dates:</div>
                <div class="col-6">{{ event.data.dates.value }}</div>
            </div>
            <div class="row" v-if="event.data.symptoms">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-procedures"></i> Symptoms:</div>
                <div class="col-6">{{ event.data.symptoms.value }}</div>
            </div>
            <div class="row" v-if="event.data.keywords">
                <div class="col-6 text-end fw-bold"> <i class="fas fa-tags"></i> Keywords:</div>
                <div class="col-6">{{ event.data.keywords.value }}</div>
            </div>
            <div class="row" v-if="event.data.places">
                <div class="col-6 text-end fw-bold">
                    <i class="fas fa-map-marker-alt"></i> Places:
                </div>
                <div class="col-6">
                    <ul class="mb-0 pl-3">
                        <li v-for="place in event.data.places" :key="place.value.name">
                            {{ place.value.name }} ({{ place.value.country }})
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row" v-if="event.text">
                <div class="col-12 resizable-text small" v-html="event.text">
                </div>
            </div>
        </div>

        <div class="card-footer">
            <a :href="event.report_url" class="btn btn-primary btn-sm" target="_blank" v-if="event.report_url">
                <i class="fas fa-file-alt"></i> Report
            </a>
            <a :href="event.related_url" class="btn btn-secondary btn-sm" target="_blank" v-if="event.related_url">
                <i class="fas fa-external-link-alt"></i> Related Link
            </a>
        </div>

    </div>
</template>

<script>

export default {
    name: "event-descriptor",
    data() {
        return {
        }
    },
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped>
.resizable-text {
    max-height: 200px;
    /* set your desired limited height */
    overflow-y: auto;
    /* add scrollbar when content exceeds the height */
    resize: vertical;

    margin-top: 25px;
    background-color: #F5F5F5; /* change this to any color you prefer */
    border: 1px solid #CCCCCC; /* adds a solid border */
    border-radius: 5px; /* adds rounded corners */
    padding: 15px; /* adds space around the text */
}
</style>